module.exports = __webpack_public_path__ + "static/ventraip-logo-160bb65a2d32c35c0842b0dea59215fd.png";